import { Injectable } from '@angular/core';
import { PluginListenerHandle } from '@capacitor/core';
import { ConnectionStatus, Network } from '@capacitor/network';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  networkStatus: ConnectionStatus;
  networkListener: PluginListenerHandle;

  constructor(private utilService: UtilService) {}

  async initNeworkStatus() {
    this.networkListener = await Network.addListener(
      'networkStatusChange',
      (status) => {
        this.networkStatus = status;
      }
    );

    this.networkStatus = await Network.getStatus();
  }

  async logCurrentStatus() {
    const status = await Network.getStatus();

    return status;
  }
}
